<template>
  <div>
    <link-button class="btn-sm float-end" @click="toggleText">
      {{ buttonText }}
    </link-button>
    <div v-show="shown" v-html="tipsHtml" />
  </div>
</template>

<script>
import LinkButton from '../components/buttons/link-button'

export default {
  components: { LinkButton },

  props: {
    tipsHtml: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      shown: false
    }
  },

  computed: {
    buttonText() {
      if (this.shown) {
        return this.i18n.t('public.petitions.write_to_target.hide_tips')
      } else {
        return this.i18n.t('public.petitions.write_to_target.show_tips')
      }
    }
  },

  methods: {
    toggleText() {
      this.shown = !this.shown
    }
  }
}
</script>
